<!-- app.component.html -->
<router-outlet></router-outlet>

<!-- Mobile/tablet overlay to force desktop usage -->
<div class="mobile-overlay" role="presentation" aria-hidden="true">
	<picture>
		<source media="(orientation: portrait) and (max-width: 1024px)" srcset="/assets/img/mobile-screen-vertical.webp">
		<source media="(orientation: landscape) and (max-width: 1024px)" srcset="/assets/img/mobile-screen-horizontal.webp">
		<img src="/assets/img/mobile-screen-vertical.webp" alt="Please use desktop" />
	</picture>
</div>